import React from 'react';

const ProgramAvailabilityPage = () => {
  return (
    <div>
      <h2>Program Availability Page</h2>
      <p>To find program availabilities first select the program you are interested in</p>
    </div>
  );
};

export default ProgramAvailabilityPage; 
